import { createFileRoute } from "@tanstack/react-router";

// Các thẻ nằm trên URL để menu / chuyển hướng /concept-guides nhảy thẳng được
// (QĐ 0096 §6.1): /costumes?tab=concepts|costumes|guides|wardrobe. Thiếu =
// concepts. "wardrobe" (Tình hình đồ, QĐ 0267) chỉ hiện với người có quyền.
export type CostumesTab = "concepts" | "costumes" | "guides" | "wardrobe";
const TABS: readonly CostumesTab[] = ["concepts", "costumes", "guides", "wardrobe"];

export type CostumesSearch = { tab?: CostumesTab | undefined };

export const Route = createFileRoute("/_app/costumes")({
  validateSearch: (search: Record<string, unknown>): CostumesSearch => {
    const tab = search.tab;
    return typeof tab === "string" && (TABS as readonly string[]).includes(tab)
      ? { tab: tab as CostumesTab }
      : {};
  },
});
